export const log = (message) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(message);
  }
};

export function getIpAddress() {
  //let ipForward = window.location.origin.split(":").slice(0, 2);
  //log(ipForward);

  //if (ipForward[1] === "//localhost") ipForward[1] = `//${ip.ip}`;
  //log(ipForward);
  //ipForward = ipForward.join(":");
  //let port = window.location.port;
  //// FIXME: it's tricky method.
  //// ME 운영 PORT를 10000번대 포트로 사용 할 경우에만 동작
  //port = parseInt(port / 10000);
  //port = `${port}${process.env.REACT_APP_ME_PORT}`;
  // const ipAddress = `${ipForward}:${port}/api`;
  const ipAddress = `${window.location.origin}/api`;
  return ipAddress;
}

export function convertData(originalData) {
  const data = originalData.data;
  const keys = Object.keys(data);
  const result = { data: [] };
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = { ...data[key] };
    value["id"] = key;
    if (value.create_date) value.create_date = formatDate(value.create_date);
    result.data.push(value);
  }
  log(result);
  return result;
}

export function convertLogData(originalData) {
  const data = originalData.data;
  const keys = Object.keys(data);
  const result = { data: [] };
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = [...data[key]];
    if (value.length === 0) continue;
    value.forEach((element) => {
      const item = {
        date: key,
        time: element[0],
        level: element[1],
        message: element[3],
      };
      result.data.push(item);
    });
  }
  result.data.sort((a, b) => {
    return new Date(b.date + " " + b.time) - new Date(a.date + " " + a.time);
  });
  return result;
}

export function convertInspRule(originalData) {
  const first = convertData(originalData);
  const result = first.data.map((item) => {
    return {
      ...item,
      options: JSON.stringify(item.options),
    };
  });
  return { data: result };
}

export function convertFlat(originalData, customKey = "id") {
  const data = originalData.data;

  function flattenData(item, info, parentKey = "", customKey) {
    let flattened = { [customKey]: item }; // Use dynamic server key
    for (const key in info) {
      if (info.hasOwnProperty(key)) {
        const newKey = parentKey ? `${parentKey}-${key}` : key;
        if (
          typeof info[key] === "object" &&
          !Array.isArray(info[key]) &&
          info[key] !== null
        ) {
          // Recursive call for nested objects
          Object.assign(
            flattened,
            flattenData(item, info[key], newKey, customKey)
          );
        } else {
          // Assign values with no modification in keys, remove ':' from newKey if exists
          const adjustedKey = newKey;
          flattened[adjustedKey] = info[key];
        }
      }
    }
    return flattened;
  }

  // Convert the data to the required format
  const output = { data: [] };
  for (const item in data) {
    if (data.hasOwnProperty(item)) {
      output.data.push(flattenData(item, data[item], "", customKey));
    }
  }

  return output;
}

export function convertTrainLog(originalData) {
  const data = originalData.data;
  const result = { data: [] };
  for (const date in data) {
    const dayData = data[date];
    for (const id in dayData) {
      const record = dayData[id];
      result.data.push({
        id,
        accuracy: JSON.stringify(record.accuracy),
        date: formatDate(record.date),
        info: JSON.stringify(record.info),
        trainInfo_id: record.trainInfo_id,
      });
    }
  }
  return result;
}

export function convertTrain(originalData) {
  const data = originalData.data;
  const keys = Object.keys(data);
  const result = { data: [] };
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = { ...data[key] };
    value["id"] = key;
    value.options = JSON.stringify(value.options);
    value.data_set = JSON.stringify(value.data_set);
    value.pp_config = JSON.stringify(value.pp_config);
    value.train_condition =
      value.train_condition.type[0] === "time"
        ? `${value.train_condition.time}분`
        : JSON.stringify(value.train_condition);
    result.data.push(value);
  }
  return result;
}

export const handleInputChange = (setFormData) => (e, field) => {
  let value = e.target.value;

  if (field === "user_name") {
    value = value.replace(/[^a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣\s]/g, "");
    setFormData((prevState) => ({
      ...prevState,
      name: value,
    }));
  } else {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  // if (field === "recipe_location" || field === "image_location") {
  //   if (
  //     value === "" ||
  //     (/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 9)
  //   ) {
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       [field]: Number(value),
  //     }));
  //   }
  // } else {
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [field]: value,
  //   }));
  // }

  if (field.endsWith("_keyword") || field.endsWith("_location")) {
    const prefix = field.split("_")[0]; // "image" 또는 "recipe"
    const result = createResult(prefix, setFormData);
    const regex = createRegex(prefix, setFormData);
    setFormData((prevState) => ({
      ...prevState,
      [`${prefix}_result`]: result(prevState), // recipe_result, image_result
      [`${prefix}_regex`]: regex(prevState),
    }));
  }
};

// regex 값을 통해 keyword, location 추출
export function extractRegex(input) {
  const keyword = input.split(",")[0];
  const location = input.split(",")[1];

  return { keyword, location };
}

export const createRegex = (prefix, setFormData) => (formData) => {
  const keyword = formData[`${prefix}_keyword`];
  const location = formData[`${prefix}_location`];

  if (!keyword) {
    return "";
  }

  if (location && location !== "0") {
    return `${keyword}, ${location}`;
  }
  return `${keyword},`;
};

export const createResult = (prefix, setFormData) => (formData) => {
  const keyword = formData[`${prefix}_keyword`];
  const location = formData[`${prefix}_location`];

  if (!keyword) {
    return "";
  }

  if (location && location !== "0" && !location.includes("-")) {
    const dollars = "$".repeat(Number(location));
    return `${dollars} ${keyword} " . . . "`;
  } else if (location && location.includes("-")) {
    const positiveLocation = location.replace("-", ""); // Remove the negative sign
    const dollars = "$".repeat(Number(positiveLocation));
    return `${dollars} ${keyword} " . . . "`;
  } else {
    return keyword;
  }
};

export const createInitialResult = (keyword, location) => {
  if (!keyword) {
    return "";
  }

  if (location && location !== "0" && !location.includes("-")) {
    const dollars = "$".repeat(Number(location));
    return `${dollars} ${keyword} " . . . "`;
  } else if (location && location.includes("-")) {
    const positiveLocation = location.replace("-", ""); // Remove the negative sign
    const dollars = "$".repeat(Number(positiveLocation));
    return `${dollars} ${keyword} " . . . "`;
  }
  return keyword;
};

// TODO: file name 에 | 문자 처리필요
export function extractFullFileName(pathString) {
  // console.log("pathString", pathString);
  let fileNames = [];
  try {
    const pathObj = JSON.parse(pathString);
    if (pathObj && typeof pathObj === "object") {
      fileNames = Object.values(pathObj).map((filePath) => {
        const parts = filePath.split("/");
        // console.log("parts", parts);
        return parts[parts.length - 1];
      });
    } else {
      const pathObj = JSON.parse(pathString);
      const parts = pathObj.split("/");
      // console.log("parts", parts);
      fileNames.push(parts[parts.length - 1]);
    }
  } catch (error) {
    const parts = pathString.split("/");
    // console.log("parts", parts[6]);
    fileNames.push(parts[parts.length - 1]);
  }
  return fileNames;
}

// 경로만 제거
export function extractFileWithExtension(pathString) {
  let fileNames = [];
  try {
    const pathObj = JSON.parse(pathString);
    if (pathObj && typeof pathObj === "object") {
      fileNames = Object.values(pathObj).map((filePath) => {
        const parts = filePath.split("/");
        const fileNameWithExtension = parts[parts.length - 1];
        return fileNameWithExtension;
      });
    } else {
      const parts = pathObj.split("/");
      const fileNameWithExtension = parts[parts.length - 1];
      fileNames.push(fileNameWithExtension);
    }
  } catch (error) {
    const parts = pathString.split("/");
    const fileNameWithExtension = parts[parts.length - 1];
    fileNames.push(fileNameWithExtension);
  }
  return fileNames;
}

export function extractAuthorities(authList) {
  let authority = [];
  try {
    const pathObj = JSON.parse(authList);
    if (Array.isArray(pathObj)) {
      authority = pathObj;
    }
  } catch (error) {
    log(error);
    const parts = authList.split(",");
    authority = parts.map((part) => part.trim());
  }
  return authority;
}

// 날짜 및 시간
export function formatDate(input) {
  if (input === null || input === undefined || input === "") {
    return "-";
  }
  const [datePart, timePart] = input.split("T");
  const [hours, minutes, seconds] = timePart.split(".")[0].split(":");

  return `${datePart.replace(/-/g, "-")} ${hours}:${minutes}:${seconds}`;
}

// 시:분:초
export function extractTime(dateString) {
  const [datePart, timePart] = dateString.split("T");
  const [hours, minutes, seconds] = timePart.split(".")[0].split(":");

  // 시간, 분, 초를 합쳐서 반환
  return `${hours}:${minutes}:${seconds}`;
}

// 시:분
export function extractHourMinute(dateString) {
  log(dateString);
  const [datePart, timePart] = dateString.split("T");
  const [hours, minutes, second] = timePart.split(".")[0].split(":");

  return `${hours}:${minutes}`;
}

// timepicker 변환 ($d)
export function extractTimePicker(dateString) {
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}

// 날짜+시간 -> 오전/오후 -시 -분으로 표현
export function formatTime(timeString) {
  // 문자열에서 시간을 추출
  const [hourString, minuteString] = timeString.split("T")[1].split(":");
  const hour = parseInt(hourString, 10);
  const minute = parseInt(minuteString, 10);

  // 오전/오후 및 12시간제로 변환
  const period = hour >= 12 ? "오후" : "오전";
  const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
  const formattedMinute = minute === 0 ? "" : ` ${minute}분`;

  return `${period} ${formattedHour}시${formattedMinute}`;
}

// 초(단위)를 받으면 시간/분/초로 return
export function formatTimeSeconds(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return `${hours > 0 ? hours + "시간 " : ""}${
    minutes > 0 ? minutes + "분 " : ""
  }${secs}초`;
}

// 빈 값 or max length에 대한 값 출력
export function truncateString(str, maxLength) {
  if (str === null || str === undefined || str === "") {
    return "-";
  }
  return str.length > maxLength ? str.substring(0, maxLength) + "..." : str;
}

// 데이터셋 클래스리스트에 따른 라벨링/카운트
export const calculateLengths = (data) => {
  log(data);
  let counts = {
    unlabeled:
      data.unlabeled && Array.isArray(data.unlabeled)
        ? data.unlabeled.length
        : 0,
  };

  if (Array.isArray(data.class_list)) {
    data.class_list.forEach((className) => {
      if (className !== "unlabeled") {
        counts[className] = 0;
      }
    });
  }

  if (Array.isArray(data.all)) {
    data.all.forEach((item) => {
      const label = item[2]; // 라벨이 항상 마지막 두 번째 항목에 있다고 가정
      if (counts.hasOwnProperty(label)) {
        counts[label]++;
      }
    });
  }

  if (Array.isArray(data.valid)) {
    data.valid.forEach((item) => {
      const label = item[2]; // 라벨이 항상 마지막 두 번째 항목에 있다고 가정
      if (counts.hasOwnProperty(label)) {
        counts[label]++;
      }
    });
  }

  return Object.keys(counts).map((label) => ({ label, count: counts[label] }));
};

export const formatDatasetListFiles = (data) => {
  const file_list = {
    unlabeled: [],
    "non-use": [],
  };

  if (data.unlabeled) {
    file_list.unlabeled = data.unlabeled.map((item) => item[1]);
  }

  if (data.all) {
    data.all.forEach((item) => {
      const label = item[2];
      if (!file_list[label]) {
        file_list[label] = [];
      }
      file_list[label].push(item[1]);
    });
  }

  if (data.valid) {
    data.valid.forEach((item) => {
      const label = item[2];
      if (!file_list[label]) {
        file_list[label] = [];
      }
      file_list[label].push(item[1]);
    });
  }

  return file_list;
};

// 빈 오브젝트 체크
export function isEmptyObj(obj) {
  if (obj.constructor === Object && Object.keys(obj).length === 0) {
    return true;
  }
  return false;
}

// inspection rule 관련 regex
export function regexSeparation(str) {
  if (typeof str !== "string") {
    throw new Error("Input must be a string");
  }

  const [first, second] = str.split(",");
  // return [first, second || "0"];
  // location이 빈값일 경우 ""로 변경 (2025-09-24 수정)
  return [first, second || ""];
}

export function formatNumber(number) {
  if (typeof number !== "number") {
    throw new Error("Input must number");
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
